// Module
var code = "<div class=\"content-section\"><div class=\"worx-site-content\"><invoices-list family-contact=\"familyContact\"></invoices-list></div></div>\n";
// Exports
module.exports = code;